import { TableBody, TableRow } from "@mui/material";
import { flexRender } from "@tanstack/react-table";
import { BACK_GROUND } from "../../../../../theme/colors";
import { useCoreTableContext } from "../CoreTable";
import CoreTableCell from "./CoreTableCell";
// import PropTypes from 'prop-types'

const CoreTableBody = () => {
  const { table, isHighlightRow } = useCoreTableContext();
  const { rows } = table?.getRowModel() || {};

  return (
    <TableBody>
      {rows?.map((row, index) => (
        <TableRow
          key={row.id}
          style={{
            backgroundColor:
              isHighlightRow && index % 2 === 1 ? BACK_GROUND : undefined,
          }}>
          {row?.getVisibleCells().map((cell) => {
            return (
              <CoreTableCell
                key={cell.id}
                {...{
                  style: {
                    width: cell.column.getSize(),
                  },
                }}>
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </CoreTableCell>
            );
          })}
        </TableRow>
      ))}
    </TableBody>
  );
};
export default CoreTableBody;
